import { useCallback } from 'react'
import moment from 'moment-timezone'

const US_STYLE_LOCALES = ['en', 'en_ca', 'en_vi', 'es_us', 'es_vi']

const FORMAT_MAPS = {
  en: {
    default: 'LLL z',
    short: 'MM/DD/YYYY',
    long: 'dddd, MMMM Do YYYY, h:mm:ss a z',
    iso: 'YYYY-MM-DDTHH:mm:ssZ',
    time: 'h:mm A z',
    date: 'LL',
    day_month_year: 'dddd, MMMM Do YYYY',
    meeting_datetime: 'MM/DD/YYYY [at] h:mm A zz',
  },
  en_gb: {
    default: 'LLL z',
    short: 'DD/MM/YYYY',
    long: 'dddd, D MMMM YYYY, h:mm:ss a z',
    iso: 'YYYY-MM-DDTHH:mm:ssZ',
    time: 'h:mm A z',
    date: 'LL',
    day_month_year: 'dddd, MMMM Do YYYY',
    meeting_datetime: 'DD/MM/YYYY [at] h:mm A zz',
  },
  // Add more specific locale formats if needed
}

// we should always pass a locale to this function for localization
// but we default to 'en' for safety
export function useFormatTime(userLocale = 'en') {
  const timezone = window.document.timeZone || moment.tz.guess()
  return useCallback(
    (date, format = 'default', locale = userLocale) => {
      // Use US-style format if locale is in the list, otherwise default to en_gb
      const effectiveLocale = US_STYLE_LOCALES.includes(locale) ? 'en' : 'en_gb'
      const formatMap = FORMAT_MAPS[effectiveLocale]
      const selectedFormat = formatMap[format] || format || formatMap.default
      if (!date) return ''
      return moment(date).tz(timezone).locale(locale).format(selectedFormat)
    },
    [timezone, userLocale],
  )
}
